var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
/* eslint-disable @typescript-eslint/no-explicit-any */
import throttle from 'lodash.throttle';
import state from '../../state';
import store from './store';
import { checkIsStarlingKey, getFleshKincaidGrade, sanitizePath, } from './utils';
import { FALLBACK_SAMPLE_RATIO, THREE_DAY, SDK_VERSION, STORAGE_KEY, } from './constant';
import { getNamespaceApiInfoMap } from '../utils';
import { fetchTranslations } from './api';
import { batchReport } from './batchReport';
var _records = null;
var _namespaceApiInfoMap = {};
var _sampleRatio = null;
var pendingQueue = [];
var reportedMissing = new Set();
var flushPendingQueue = function () {
    pendingQueue.forEach(function (_a) {
        var recordKey = _a.recordKey, params = _a.params;
        collect(recordKey, params);
    });
    pendingQueue.length = 0;
};
export var setupKeyCollection = function (_a) {
    var projects = _a.projects, collectSampleRatio = _a.collectSampleRatio;
    return __awaiter(void 0, void 0, void 0, function () {
        var now, btm, data, _1;
        var _b;
        return __generator(this, function (_c) {
            switch (_c.label) {
                case 0:
                    _namespaceApiInfoMap = getNamespaceApiInfoMap(projects);
                    now = Date.now();
                    _c.label = 1;
                case 1:
                    _c.trys.push([1, 3, , 4]);
                    btm = state.btm;
                    if (collectSampleRatio) {
                        _sampleRatio = collectSampleRatio;
                    }
                    else {
                        (_b = btm === null || btm === void 0 ? void 0 : btm.on) === null || _b === void 0 ? void 0 : _b.call(btm, 'config', function (config) {
                            var _a, _b;
                            try {
                                _sampleRatio =
                                    (_b = (_a = config === null || config === void 0 ? void 0 : config.copywritingConfig) === null || _a === void 0 ? void 0 : _a.starlingSampleRatio) !== null && _b !== void 0 ? _b : FALLBACK_SAMPLE_RATIO;
                                flushPendingQueue();
                            }
                            catch (_) {
                                // empty
                            }
                        });
                    }
                    return [4 /*yield*/, store.getItem(STORAGE_KEY)];
                case 2:
                    data = _c.sent();
                    if (!data ||
                        typeof data.timestamp !== 'number' ||
                        data.timestamp > now ||
                        typeof data.keys !== 'object' ||
                        data.version !== SDK_VERSION) {
                        throw new Error('Invalid collected key record');
                    }
                    if (data.timestamp + THREE_DAY < now) {
                        throw new Error('Expired');
                    }
                    _records = data;
                    return [3 /*break*/, 4];
                case 3:
                    _1 = _c.sent();
                    _records = {
                        version: SDK_VERSION,
                        timestamp: now,
                        keys: {},
                    };
                    return [3 /*break*/, 4];
                case 4: return [2 /*return*/];
            }
        });
    });
};
// language -> namespace -> key -> value;
var translations = {};
export var teaCollectKey = function (payload) { return __awaiter(void 0, void 0, void 0, function () {
    var btm, key_1, language_1, projectAndNamespace_1, _a, host, rawPathname, pathname, recordKey, btmInfo, commonParams, _b, text, usedNamespace, readingEase, params, _2;
    var _c, _d;
    return __generator(this, function (_e) {
        switch (_e.label) {
            case 0:
                _e.trys.push([0, 2, , 3]);
                btm = state.btm;
                if (!btm)
                    return [2 /*return*/];
                key_1 = payload.key, language_1 = payload.language, projectAndNamespace_1 = payload.projectAndNamespace;
                if (!key_1)
                    return [2 /*return*/];
                if (!checkIsStarlingKey(key_1))
                    return [2 /*return*/];
                _a = window.location, host = _a.host, rawPathname = _a.pathname;
                pathname = sanitizePath(rawPathname);
                recordKey = "path:".concat(pathname, "|lang:").concat(language_1, "|key:").concat(key_1, "|ns:").concat(projectAndNamespace_1.join(','));
                if (((_c = _records === null || _records === void 0 ? void 0 : _records.keys) === null || _c === void 0 ? void 0 : _c[recordKey]) || reportedMissing.has(recordKey)) {
                    return [2 /*return*/];
                }
                btmInfo = (_d = btm.getPageBtmInfo) === null || _d === void 0 ? void 0 : _d.call(btm).btm;
                commonParams = {
                    btm: btmInfo,
                    version: SDK_VERSION,
                    starling_key: key_1,
                    namespace: projectAndNamespace_1.join(','),
                    host: host,
                    pathname: pathname,
                    language: language_1,
                };
                return [4 /*yield*/, loadTranslations({ projectAndNamespace: projectAndNamespace_1, language: language_1 })];
            case 1:
                _e.sent();
                _b = (function () {
                    var _a, _b;
                    if (!projectAndNamespace_1.length)
                        return { text: null, usedNamespace: null };
                    for (var _i = 0, projectAndNamespace_2 = projectAndNamespace_1; _i < projectAndNamespace_2.length; _i++) {
                        var ns = projectAndNamespace_2[_i];
                        if (((_b = (_a = translations[language_1]) === null || _a === void 0 ? void 0 : _a[ns]) === null || _b === void 0 ? void 0 : _b[key_1]) != null) {
                            return { text: translations[language_1][ns][key_1], usedNamespace: ns };
                        }
                    }
                    return { text: null, usedNamespace: null };
                })(), text = _b.text, usedNamespace = _b.usedNamespace;
                if (text) {
                    readingEase = language_1.startsWith('en')
                        ? getFleshKincaidGrade(text)
                        : undefined;
                    params = __assign(__assign(__assign({}, commonParams), readingEase), { text: text, namespace: usedNamespace });
                    if (_sampleRatio == null) {
                        pendingQueue.push({ recordKey: recordKey, params: params });
                        return [2 /*return*/];
                    }
                    collect(recordKey, params);
                }
                else {
                    collectMissing(recordKey, commonParams);
                }
                return [3 /*break*/, 3];
            case 2:
                _2 = _e.sent();
                return [3 /*break*/, 3];
            case 3: return [2 /*return*/];
        }
    });
}); };
function collect(recordKey, params) {
    var _a;
    if (_sampleRatio == null)
        return;
    if (Math.random() > _sampleRatio)
        return;
    if ((_a = _records === null || _records === void 0 ? void 0 : _records.keys) === null || _a === void 0 ? void 0 : _a[recordKey]) {
        return;
    }
    batchReport('btm_copywriting_starling', params);
    if (_records === null || _records === void 0 ? void 0 : _records.keys) {
        _records.keys[recordKey] = true;
    }
    syncRecordToStorage();
}
function collectMissing(recordKey, params) {
    if (reportedMissing.has(recordKey)) {
        return;
    }
    batchReport('btm_copywriting_starling_missing', params);
    reportedMissing.add(recordKey);
}
var syncRecordToStorage = throttle(function () { return __awaiter(void 0, void 0, void 0, function () {
    var e_1;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                if (!_records)
                    return [2 /*return*/];
                _a.label = 1;
            case 1:
                _a.trys.push([1, 3, , 4]);
                return [4 /*yield*/, store.setItem(STORAGE_KEY, _records)];
            case 2:
                _a.sent();
                return [3 /*break*/, 4];
            case 3:
                e_1 = _a.sent();
                return [3 /*break*/, 4];
            case 4: return [2 /*return*/];
        }
    });
}); }, 5000);
var ongoingFetch = {};
var loadedNamespace = new Set();
var loadTranslations = function (_a) {
    var projectAndNamespace = _a.projectAndNamespace, language = _a.language;
    return __awaiter(void 0, void 0, void 0, function () {
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0: return [4 /*yield*/, Promise.all(projectAndNamespace.map(function (ns) {
                        var apiInfo = _namespaceApiInfoMap[ns];
                        if (!apiInfo)
                            return;
                        var key = "".concat(ns, "_").concat(language);
                        if (loadedNamespace.has(key))
                            return;
                        if (!ongoingFetch[key]) {
                            ongoingFetch[key] = (function () { return __awaiter(void 0, void 0, void 0, function () {
                                var strings, e_2;
                                return __generator(this, function (_a) {
                                    switch (_a.label) {
                                        case 0:
                                            _a.trys.push([0, 3, , 4]);
                                            return [4 /*yield*/, new Promise(function (res) {
                                                    setTimeout(res, 5000);
                                                })];
                                        case 1:
                                            _a.sent();
                                            return [4 /*yield*/, fetchTranslations({
                                                    namespace: apiInfo.namespace,
                                                    apiKey: apiInfo.apiKey,
                                                    locale: language,
                                                })];
                                        case 2:
                                            strings = _a.sent();
                                            if (!translations[language]) {
                                                translations[language] = {};
                                            }
                                            translations[language][ns] = strings;
                                            loadedNamespace.add(key);
                                            delete ongoingFetch[key];
                                            return [3 /*break*/, 4];
                                        case 3:
                                            e_2 = _a.sent();
                                            delete ongoingFetch[key];
                                            throw e_2;
                                        case 4: return [2 /*return*/];
                                    }
                                });
                            }); })();
                        }
                        return ongoingFetch[key];
                    }))];
                case 1:
                    _b.sent();
                    return [2 /*return*/];
            }
        });
    });
};
